module.exports = __webpack_public_path__ + "static/media/seller.5802c559.svg";